module.exports = __webpack_public_path__ + "resources/img/3@3x.e189d188.png";